import React, { useState, useEffect } from 'react';
import './Calendar.css'; // Ensure this CSS file is imported

const Calendar = ({ onDateSelect, selectedDate, initialMonth }) => {
  // State to track current date
  const [currentDate, setCurrentDate] = useState(initialMonth || new Date());

  useEffect(() => {
    if (initialMonth) {
      setCurrentDate(initialMonth);
    }
  }, [initialMonth]);

  // Function to change month
  const changeMonth = (direction) => {
    setCurrentDate(prevDate => {
      const newDate = new Date(prevDate);
      newDate.setMonth(newDate.getMonth() + direction);
      return newDate;
    });
  };

  // Function to handle date click
  const handleDateClick = (date) => {
    onDateSelect(date); // Call the onDateSelect prop with the clicked date
  };

  return (
    <div className="calendar">
      <div className="calendar-header">
        <button onClick={() => changeMonth(-1)}>Previous</button>
        <span>{currentDate.toLocaleString('default', { month: 'long' })} {currentDate.getFullYear()}</span>
        <button onClick={() => changeMonth(1)}>Next</button>
      </div>
      <div className="calendar-body">
        {generateCalendar(currentDate, handleDateClick, selectedDate)}
      </div>
    </div>
  );
};

// Function to generate calendar dates
const generateCalendar = (currentDate, handleDateClick, selectedDate) => {
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();
  const firstDayOfMonth = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const weeks = [];
  let days = [];
  let dayCount = 1;

  // Fill the first week
  for (let i = 0; i < 7; i++) {
    if (i < firstDayOfMonth) {
      days.push(<div key={`empty-${i}`} className="calendar-day empty"></div>);
    } else {
      const date = new Date(year, month, dayCount);
      const isSelected = selectedDate && date.toDateString() === selectedDate.toDateString();
      days.push(
        <div
          key={`day-${dayCount}`}
          className={`calendar-day ${isSelected ? 'selected' : ''}`}
          onClick={() => handleDateClick(date)}
        >
          {dayCount++}
        </div>
      );
    }
  }
  weeks.push(<div key={`week-1`} className="calendar-week">{days}</div>);

  // Fill the rest of the weeks
  while (dayCount <= daysInMonth) {
    days = [];
    for (let i = 0; i < 7; i++) {
      if (dayCount > daysInMonth) {
        days.push(<div key={`empty-${i}-${dayCount}`} className="calendar-day empty"></div>);
      } else {
        const date = new Date(year, month, dayCount);
        const isSelected = selectedDate && date.toDateString() === selectedDate.toDateString();
        days.push(
          <div
            key={`day-${dayCount}`}
            className={`calendar-day ${isSelected ? 'selected' : ''}`}
            onClick={() => handleDateClick(date)}
          >
            {dayCount++}
          </div>
        );
      }
    }
    weeks.push(<div key={`week-${weeks.length + 1}`} className="calendar-week">{days}</div>);
  }

  return weeks;
};

export default Calendar;




